const pages = "/auth/"

export const UPDATE_AUTH_DATA = `${pages}UPDATE_AUTH_DATA`;
export const UPDATE_FORM_STATUS = `${pages}UPDATE_FORM_STATUS`;

